module.exports = __webpack_public_path__ + "img/ph.ef58b1d7.png";